var map = {
	"./accounts.routes.js": "5f1c",
	"./agents.routes.js": "d8c1",
	"./auth.routes.js": "0d7d",
	"./banks.routes.js": "c3e3",
	"./customers.routes.js": "3f7e",
	"./http.routes.js": "ba0a",
	"./integrations.routes.js": "c295",
	"./invoices.routes.js": "5753",
	"./orders.routes.js": "f856",
	"./payments.routes.js": "1fa5",
	"./purchases.routes.js": "988c",
	"./reports.routes.js": "1f68",
	"./subscriptions.routes.js": "3c1a",
	"./suppliers.routes.js": "63b1",
	"./supporting-documents.routes.js": "61e7",
	"./widgets.routes.js": "0782"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0196";